/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type RelinkInLevel = typeof RelinkInLevel[keyof typeof RelinkInLevel];


export const RelinkInLevel = {
  job: 'job',
  job_candidate: 'job_candidate',
} as const;
